import { render, staticRenderFns } from "./ComplianceQuestionnaire.vue?vue&type=template&id=3dd80661&scoped=true"
import script from "./ComplianceQuestionnaire.vue?vue&type=script&lang=js"
export * from "./ComplianceQuestionnaire.vue?vue&type=script&lang=js"
import style0 from "./ComplianceQuestionnaire.vue?vue&type=style&index=0&id=3dd80661&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd80661",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dd80661')) {
      api.createRecord('3dd80661', component.options)
    } else {
      api.reload('3dd80661', component.options)
    }
    module.hot.accept("./ComplianceQuestionnaire.vue?vue&type=template&id=3dd80661&scoped=true", function () {
      api.rerender('3dd80661', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MerchantKYC/components/ComplianceQuestionnaire.vue"
export default component.exports